import React from "react";
import TipCallout from "./TipCallout";
import {
  SCROLL_OFFSET,
  ARTICLE_COLUMN,
  H2_TIGHT,
  BODY,
  BODY_SM,
  CARD_TITLE,
  STACK_GAP,
} from "./sections";

const STEPS = [
  {
    title: "Open your AI tool",
    body: "Open ChatGPT, Claude, or Gemini in your browser or app as you normally would.",
  },
  {
    title: "Click into the chat box",
    body: "Click into the chat input box, just like you are about to type.",
  },
  {
    title: "Activate the microphone",
    body: "Activate Zero Typing AI's floating microphone icon, or your set keyboard shortcut.",
  },
  {
    title: "Speak your prompt naturally",
    body: "Say it in whatever order makes sense to you: background, task, and desired format.",
  },
  {
    title: "Let it transcribe and clean up",
    body: "Zero Typing AI transcribes your speech and applies AI-powered formatting and cleanup, so filler words and false starts do not end up in your prompt.",
  },
  {
    title: "Review and send",
    body: "Glance at the dictated prompt in the input box, make any quick edits, and send it.",
  },
];

const HowToUseSection = () => {
  return (
    <section
      id="how-to-use"
      style={{ scrollMarginTop: `${SCROLL_OFFSET}px` }}
      className={ARTICLE_COLUMN}
    >
      <h2 className={H2_TIGHT}>
        How To Use Voice Prompting AI With ChatGPT, Claude, And Gemini
      </h2>

      <p className={`${STACK_GAP} ${BODY}`}>
        With Zero Typing AI, the process is the same across all three tools,
        because the dictation runs as an overlay on top of whatever app is open.
        It is not a separate feature built into each chatbot individually.
      </p>

      {/* Numbered timeline - dots sit on a continuous rail */}
      <div className="pt-[30.05px]">
        <ol className="relative">
          {/* Rail runs between the first and last dot centres */}
          <span
            aria-hidden="true"
            className="absolute left-[14px] top-[14px] bottom-[14px] w-[2px] bg-[#DCEEFB]"
          />

          {STEPS.map(({ title, body }, index) => (
            <li
              key={title}
              className={`relative flex gap-[17.17px] ${
                index === 0 ? "" : "mt-[25.76px]"
              }`}
            >
              <span
                aria-hidden="true"
                className="mt-[2px] h-[28px] w-[28px] shrink-0 rounded-full bg-gradient-to-r from-[#3AB1F6] to-[#407BFF]"
              />

              <div className="min-w-0">
                <h3 className={CARD_TITLE}>{title}</h3>
                <p className={`mt-[4px] ${BODY_SM}`}>{body}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>

      <TipCallout>
        If you use the same type of prompt often, for example always asking for
        a specific tone or output format, set up a custom prompt in Zero Typing
        AI so that structure gets applied automatically every time you dictate.
      </TipCallout>
    </section>
  );
};

export default HowToUseSection;
